import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lp-wave" }

import LoanproLogo from '@/views/Common/components/LoanproLogo.vue'
import PismoAboveForm from '@/views/Login/components/PismoAboveForm.vue'
import GalileoAboveForm from '@/views/Login/components/GalileoAboveForm.vue'
import MasterCardAboveForm from '@/views/Login/components/MasterCardAboveForm.vue'
import ExperianAboveForm from './views/Login/components/ExperianAboveForm.vue'
import ThreddAboveForm from './views/Login/components/ThreddAboveForm.vue'
import { onMounted, computed } from 'vue'
import { useConfigSync } from '@/config/useConfig'

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const config = useConfigSync()

const aboveForm = computed(() => {
  return config?.looknfeel?.login_above_form || 'default'
})

onMounted(async () => {
  // Dynamically load lp-wave.js when the component is mounted
  import('@/assets/js/lp-wave.js')
    .then(() => {
      console.log('lp-wave.js loaded successfully.')
    })
    .catch((error) => {
      console.error('Failed to load lp-wave.js:', error)
    })
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (aboveForm.value == 'default')
      ? (_openBlock(), _createBlock(LoanproLogo, { key: 0 }))
      : _createCommentVNode("", true),
    (aboveForm.value == 'pismo')
      ? (_openBlock(), _createBlock(PismoAboveForm, {
          key: 1,
          class: "lp-float-logo"
        }))
      : _createCommentVNode("", true),
    (aboveForm.value == 'galileo')
      ? (_openBlock(), _createBlock(GalileoAboveForm, {
          key: 2,
          class: "lp-float-logo"
        }))
      : _createCommentVNode("", true),
    (aboveForm.value == 'mastercard')
      ? (_openBlock(), _createBlock(MasterCardAboveForm, {
          key: 3,
          class: "lp-float-logo"
        }))
      : _createCommentVNode("", true),
    (aboveForm.value == 'experian')
      ? (_openBlock(), _createBlock(ExperianAboveForm, {
          key: 4,
          class: "lp-float-logo"
        }))
      : _createCommentVNode("", true),
    (aboveForm.value == 'thredd')
      ? (_openBlock(), _createBlock(ThreddAboveForm, {
          key: 5,
          class: "lp-float-logo"
        }))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "lp-wave-bg" }, [
      _createElementVNode("div", { class: "lp-wave-bg-scene" }),
      _createElementVNode("div", { class: "lp-wave-bg-overlay" })
    ], -1)),
    _createVNode(_component_router_view)
  ]))
}
}

})